import { addTransientVarName } from '../../../saveLoad/client/transientVars';

export const IN_SHOP_VAR_NAME = 'in_shop';
addTransientVarName(IN_SHOP_VAR_NAME);
export const CURRENT_INVENTORY_TAB_VAR_NAME = 'current_inventory_tab';
addTransientVarName(CURRENT_INVENTORY_TAB_VAR_NAME);
export const IN_DESCRIPTION_VAR_NAME = 'in_description';
addTransientVarName(IN_DESCRIPTION_VAR_NAME);
